import Button from 'components/commons/buttons/button/Button';
import SearchInput from 'components/commons/inputs/SearchInput/SearchInput';
import ModalInfo from 'components/templates/modalInfo/ModalInfo';
import { useState } from 'react';
import ModalNewPassword from '../modalNewPassword/ModalNewPassword';
import PasswordInput from 'components/commons/inputs/passwordInput/PasswordInput';
import { useTranslate } from 'context/languageContext';
import { useDispatch, useSelector } from 'react-redux';
import { useLoginUserMutation } from 'redux/services/userService';
import { updateContextualMessage, updateShowLoading } from 'redux/slices/contextualSlice';
import { updateUserData, userState } from 'redux/slices/userSlice';
import { IUser } from 'types/interfaces';

import './modalSignIn.scss';

export default function ModalSignIn({ onClose, onAceptar }) {
  const [newPasswordModal, setNewPasswordModal] = useState(false);
  const [user, setUser] = useState<IUser | undefined>(undefined);
  const [statusMessage, setStatusMessage] = useState('');
  const account = useSelector(userState);

  const t = useTranslate();
  const dispatch = useDispatch() as any;
  const [login] = useLoginUserMutation();

  const userValidation = () => {
    if (
      user?.email !== undefined &&
      user?.email?.length > 0 &&
      user?.password !== undefined &&
      user?.password?.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };
  const handleAceptar = async () => {
    dispatch(updateShowLoading(true));
    if (userValidation()) {
      let body = {
        email: user?.email?.toLowerCase(),
        password: user?.password,
        deviceTypeId: account.deviceTypeId,
        tokenDevice: account.tokenDevice,
      };
      const result: any = await login({ body: body, token: account.bearerToken });
      /* Capturando msj de error */
      setStatusMessage(result?.error?.data?.mensaje);
      setTimeout(() => {
        setStatusMessage('');
      }, 3000);
      /* ************************* */
      if (result.data) {
        localStorage.setItem(
          'userAccountInformation',
          JSON.stringify({
            ...account,
            ...result.data,
          }),
        );
        dispatch(updateUserData(result.data));
        onClose(false);
      } else {
        dispatch(updateContextualMessage({ message: result?.error?.data?.mensaje, type: 'error' }));
      }
    }
    dispatch(updateShowLoading(false));
  };

  return (
    <>
      {!newPasswordModal && (
        <ModalInfo closeAction={() => onClose()} width='400px' height='auto'>
          <div className='modal-sign-in'>
            <h3>{t('iniciar_sesion')}</h3>
            <div className='modal-sign-in-inputs'>
              <SearchInput
                name='modal-email-input'
                placeholder='Email'
                actionOnChange={(e) => setUser({ ...user, email: e })}
                className='modal-sign-in-input'
              />

              <PasswordInput
                placeholder={t('lb_configuracion_password')}
                actionOnChange={(e) => setUser({ ...user, password: e })}
                className='modal-sign-in-input'
              />
            </div>
            <div className='modal-sign-in-pwd-recovery'>
              <span
                onClick={() => {
                  setNewPasswordModal(true);
                }}
              >
                {t('lb_configuracion_recuperar_password')}
              </span>
            </div>

            {statusMessage && <p className='status-msg'>{statusMessage}</p>}
            <div className='modal-sign-in-actions'>
              <Button
                title={t('lb_cancelar')}
                className={'btn-cancelar'}
                width='50%'
                onClick={() => onClose()}
              />
              <Button
                title={t('lb_aceptar')}
                className={'btn-aceptar'}
                width='50%'
                onClick={() => handleAceptar()}
              />
            </div>
          </div>
        </ModalInfo>
      )}
      {newPasswordModal && (
        <ModalNewPassword onClose={() => setNewPasswordModal(!ModalNewPassword)} />
      )}
    </>
  );
}
